import { IOrderData } from "@interfaces";
import wtApiClient from "./wtApiClient";
import ftApiClient from "./ftApiClient";

export const bookingApi = {
    getBookingVoucher: (orderId: string | number) => {
        const url = `/voucher/${orderId}.json`;
        return wtApiClient.get(url);
    },
    getBookingReference: () => {
        const url = "/bookingreference";
        return wtApiClient.post(url);
    },
    getPaymentMethod: () => {
        const url = "/agent/paymentmethods";
        return wtApiClient.get(url);
    },
    order: (body: IOrderData) => {
        const url = "/order";
        return wtApiClient.post(url, body);
    },
    completeOrder: (params: string) => {
        const url = `/cart/order/complete${params}`;
        return ftApiClient.put(url, {});
    },
    getListBooking: () => {
        const url = `/cart/bookings`;
        return ftApiClient.get(url);
    },

    getAllBookings: () => {
        const url = `/booking/all`;
        return ftApiClient.get(url);
    },

    getListCustomerOrder: () => {
        const url = "/customerOrderDetail?since=9-jun-2021&searchOnlyStatus=Quote";
        return wtApiClient.get(url);
    },
    getBookingDetail: (id: string | number) => {
        const url = `voucher/${id}.json`;
        return wtApiClient.get(url);
    },
    convertQuoteToOrder: (bookingReference: string) => {
        const url = `/order/${bookingReference}/convertQuote`;
        return wtApiClient.post(url);
    },
};
